module.exports = __webpack_public_path__ + "static/media/meal_period.50c31962.svg";